<template>
  <GmapMap
    style="
      width: 100%;
      min-height: 220px;
      max-height: 250px;
      border-radius: 15px 15px 0px 0px;
      overflow: hidden;
    "
    :zoom="zoom"
    :center="location"
    ref="map"
  >
    <GmapMarker :position="location" />
  </GmapMap>
</template>
<script>
export default {
  props: {
    zoom: {
      type: Number,
      default: 13,
      required: false,
    },
    location: {
      type: Object,
      required: true,
    },
  },
};
</script>
